export default ({ text, href, label, lang, dir }) => `
<a title="${text}" href="${href}" aria-label="${label}" lang="${lang}" dir="${dir}">${text}</a>
`;
